import {client} from './services/client'

export  const settingtransactions = {
    namespaced:true,
    state:{
        settingtransactions:[],
        themarchand:undefined,
        load:true,

    },
    mutations: {
        SET_SETTINGS (state,marchand,themarchand){
            state.settingtransactions = marchand;
            state.themarchand = themarchand;
        },
        SET_SETTINGMHDS (state,themarchand){
            state.themarchand = themarchand;
        },
        SET_LAOD (state,marchand){
            state.load = marchand
        },

    },
    actions: {
        getDevises({commit}){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/devises/get',
                })
                    .then((response)=>{
                        let devises = response.data.devises;
                        commit('SET_DEVISES',devises)

                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },
        setSetting({commit},data){
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/settingtransactions/set',
                    data:data,
                })
                    .then((response)=>{
                        let settingtransactions = response.data.settingtransactions;
                        commit('SET_SETTINGS',settingtransactions);

                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        }
        ,updateSetting({commit},data){
            commit('SET_LAOD',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/settingtransactions/update',
                    data:data,
                })
                    .then((response)=>{
                        let settingtransactions = response.data.settingtransactions;
                        commit('SET_SETTINGS',settingtransactions);
                        commit('SET_LAOD',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteSetting({commit},data){
            commit('SET_LAOD',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/settingtransactions/delete',
                    data:data,
                })
                    .then((response)=>{
                        let settingtransactions = response.data.settingtransactions;
                        commit('SET_SETTINGS',settingtransactions);
                        commit('SET_LAOD',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        getMarchandWithSetting({commit},data){
            commit('SET_LAOD',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/settingtransactions/get/with/setting',
                    data:data
                })
                    .then((response)=>{
                        let marchand = response.data.marchand;
                        commit('SET_SETTINGS',marchand)
                        commit('SET_SETTINGMHDS',response.data.themarchand)
                        commit('SET_LAOD',false)
                        resolve(response)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })
        },

    },
    getters: {
      getSettingTransactions: state  => {
          return state.settingtransactions
      },
    }
};
